<template>
  <v-tooltip
    top
    max-width="500"
  >
    <template v-slot:activator="{ on: onTooltip }">
      <v-select
        v-model="anoSelecionado"
        :items="anos"
        :label="label"
        prepend-icon="edit_calendar"
        :rules="rules"
        :disabled="desabilitado"
        v-on="{ ...onTooltip }"
      />
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
import Data from '@/modules/data';

export default {
  name: 'AppYearSelect',

  props: {
    value: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      default: 'Ano',
      required: false,
    },
    tooltip: {
      type: String,
      default: 'Selecione o ano',
      required: false,
    },
    rules: {
      type: Array,
      default: () => [],
      required: false,
    },
    desabilitado: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  data() {
    return {
      anos: [],
    };
  },

  computed: {
    anoSelecionado: {
      get() {
        return this.value ? this.value : Data.get().year();
      },
      set(v) {
        this.$emit('input', v);
      },
    },
  },

  created() {
    for (let ano = 2020; ano <= Data.get().add(5, 'years').year(); ano += 1) {
      this.anos.push(ano);
    }
  },
};
</script>
